import React, { useState } from 'react';
import classNames from 'classnames';

import css from './FavorateButton.module.scss';
import heartIconOutline from '../../assets/heartOutlined.webp';
import heartIconFilled from '../../assets/heart.webp';

export const FavorateButton = (props) => {
  const { currentUser, listing, onToggleFavorites } = props;
  
  const isFavorite = currentUser?.attributes?.profile?.privateData?.favorites?.includes(
    listing.id.uuid
  );

  const toggleFavorites = () => onToggleFavorites(isFavorite);

  return (
    <div className={css.FavorateButton} onClick={toggleFavorites}>
      <img src={heartIconOutline}/>
      <img style={isFavorite ? {}:{transform:"scale(0.0)"}} src={heartIconFilled}/>
    </div>
  )
}

export default FavorateButton;